{% block acris_faq_detail %}
    <sw-page class="acris-faq-detail" v-if="item">

        {% block acris_faq_detail_smart_bar_header %}
            <template #smart-bar-header>
                {% block acris_faq_detail_smart_bar_header_title %}
                    <h2>{{ $tc('acris-faq.detail.textHeadline') }}</h2>
                {% endblock %}
            </template>
        {% endblock %}


        {% block acris_faq_detail_smart_bar_language %}
            <template #language-switch>
                <sw-language-switch @on-change="onChangeLanguage"
                                    :disabled="$route.params.newItem"></sw-language-switch>
            </template>
        {% endblock %}


        {% block acris_faq_detail_smart_bar_actions %}
            <template #smart-bar-actions>
                {% block acris_faq_detail_smart_bar_actions_cancel %}
                    <mt-button :disabled="item.isLoading" @click="$router.push({ name: 'acris.faq.index' })" size="default" variant="secondary">
                        {{ $tc('acris-faq.detail.buttonCancel') }}
                    </mt-button>
                {% endblock %}

                {% block acris_faq_detail_smart_bar_actions_save %}
                    <sw-button-process
                        class="acris-faq-detail__save-action"
                        :isLoading="isLoading"
                        :processSuccess="processSuccess"
                        variant="primary"
                        :disabled="isDisabled"
                        @update:processSuccess="saveFinish"
                        @click="onClickSave">
                        {{ $tc('acris-faq.detail.buttonSave') }}
                    </sw-button-process>
                {% endblock %}
            </template>
        {% endblock %}

        {% block acris_faq_detail_content %}
        <template #content>
                <sw-card-view>

                {% block acris_faq_detail_info_card %}
                    <mt-card :isLoading="isLoading" v-if="item && !isNewItem"
                             position-identifier="acris-faq-detail-info"
                             :title="$tc('acris-faq.detail.cardInfo')">

                        {% block acris_faq_detail_info_id %}
                            <mt-text-field v-model="item.id"
                                           disabled
                                           copyable
                                           class="acris-faq-detail__item_id"
                                           :label="$tc('acris-faq.detail.fieldTitleLabelId')">
                            </mt-text-field>
                        {% endblock %}

                        {% block acris_faq_detail_info_technical_url %}
                            <mt-text-field v-model="technicalUrl"
                                           disabled
                                           copyable
                                           class="acris-faq-detail__item_technical_url"
                                           :label="$tc('acris-faq.detail.fieldTitleLabelTechnicalUrl')"
                                           :helpText="$tc('acris-faq.detail.fieldTitleHelpTextTechnicalUrl', 0, { placeholder: domainPlaceholder })">
                            </mt-text-field>
                        {% endblock %}

                        {% block acris_faq_detail_info_seo_url %}
                            <acris-faq-seo-url
                                    is-input-disabled
                                    copyable
                                    :is-loading="isLoading"
                                    :has-default-template="false"
                                    :urls="item.seoUrls">
                            </acris-faq-seo-url>
                        {% endblock %}
                    </mt-card>
                {% endblock %}

                {% block acris_faq_detail_base_acris_document_modal %}
                    <sw-media-modal-v2
                        v-if="showDocumentModal"
                        :initialFolderId="documentDefaultFolderId"
                        :entityContext="item.getEntityName()"
                        @media-modal-selection-change="onAddDocument"
                        @modal-close="onCloseDocumentModal">
                    </sw-media-modal-v2>
                {% endblock %}

                {% block acris_faq_detail_content_card %}
                    <mt-card :isLoading="isLoading" v-if="item"
                             position-identifier="acris-faq-detail-content"
                             :title="$tc('acris-faq.detail.cardTitle')">

                        {% block acris_faq_detail_content_internal_name %}
                            <mt-text-field v-model="item.internalName"
                                           class="acris-faq-detail__item_internal_name"
                                           :label="$tc('acris-faq.detail.fieldTitleLabelInternalName')"
                                           :placeholder="placeholder(item, 'internalName', $tc('acris-faq.detail.fieldTitlePlaceholderInternalName'))">
                            </mt-text-field>
                        {% endblock %}

                        {% block acris_faq_detail_content_layout %}
                            <sw-single-select v-model:value="item.layout"
                                              :options="layoutOptions"
                                              :label="$tc('acris-faq.detail.fieldTitleLabelLayout')">
                            </sw-single-select>
                        {% endblock %}

                        {% block acris_faq_detail_content_name %}
                            <mt-text-field v-model="item.name"
                                           required
                                           class="acris-faq-detail__item_name"
                                           :label="$tc('acris-faq.detail.fieldTitleLabelName')"
                                           :placeholder="placeholder(item, 'name', $tc('acris-faq.detail.fieldTitlePlaceholderName'))">
                            </mt-text-field>
                        {% endblock %}
                        {% block acris_faq_content_keyword_add_modal %}
                            <sw-modal v-if="currentKeyword"
                                      @modal-close="onCloseKeywordModal"
                                      :title="$tc('acris-faq.detail.fieldTitleLabelKeywordName')">
                                {% block acris_faq_content_keyword_add_modal_field_form %}
                                    <acris-faq-keyword-modal-form :keyword="currentKeyword"
                                                                  :item="item"
                                                                  v-if="item">
                                    </acris-faq-keyword-modal-form>
                                {% endblock %}

                                {% block acris_faq_content_keyword_add_modal_footer %}
                                    <template #modal-footer>
                                        {% block acris_faq_content_keyword_add_modal_cancel %}
                                            <mt-button size="small" @click="onCloseKeywordModal" variant="secondary">
                                                {{ $tc('acris-faq.detail.buttonCancel') }}
                                            </mt-button>
                                        {% endblock %}

                                        {% block acris_faq_content_keyword_add_modal_apply %}
                                            <mt-button variant="primary" size="small" @click="onSaveKeyword"
                                                       :disabled="!currentKeyword.name">
                                                {{ $tc('acris-faq.detail.buttonSave') }}
                                            </mt-button>
                                        {% endblock %}
                                    </template>
                                {% endblock %}
                            </sw-modal>
                        {% endblock %}
                        {% block acris_faq_detail_content_description %}
                            <mt-banner>
                                {{ $tc('acris-faq.detail.descriptionInfoText') }}
                            </mt-banner>

                            <sw-text-editor v-model:value="item.description"
                                            name="description"
                                            sanitize-input
                                            sanitize-field-name="acris_faq_translation.description"
                                            class="acris-faq-detail__item_description"
                                            :label="$tc('acris-faq.detail.fieldTitleLabelDescription')"
                                            :placeholder="placeholder(item, 'description', $tc('acris-faq.detail.fieldTitlePlaceholderDescription'))">
                            </sw-text-editor>
                        {% endblock %}

                        {% block acris_faq_detail_content_priority %}
                            <mt-number-field v-model="item.priority"
                                             numberType="float"
                                             class="acris-faq-detail__item_priority"
                                             :label="$tc('acris-faq.detail.fieldTitleLabelPriority')"
                                             :helpText="$tc('acris-faq.detail.fieldTitleHelpTextPriority')"
                                             :placeholder="$tc('acris-faq.detail.fieldTitlePlaceholderPriority')">
                            </mt-number-field>
                        {% endblock %}

                        {% block acris_faq_detail_content_active_checkbox_select %}
                            <mt-switch v-model="item.active"
                                      class="acris-faq-detail__item_active"
                                      :label="$tc('acris-faq.detail.fieldTitleLabelActive')"
                                      :helpText="$tc('acris-faq.detail.fieldTitleHelpTextActive')">
                            </mt-switch>
                        {% endblock %}

                        {% block acris_faq_detail_content_sales_channel %}
                            <sw-entity-many-to-many-select
                                    v-if="item.salesChannels"
                                    :localMode="true"
                                    :label="$tc('acris-faq.detail.fieldTitleLabelSalesChannel')"
                                    :helpText="$tc('acris-faq.detail.fieldTitleHelpTextSalesChannel')"
                                    :placeholder="$tc('acris-faq.detail.fieldTitlePlaceholderSalesChannel')"
                                    :entity-collection="item.salesChannels"
                                    @update:entity-collection="onSalesChannelChange">
                            </sw-entity-many-to-many-select>
                        {% endblock %}

                        {% block acris_faq_detail_content_rule %}
                            <sw-entity-many-to-many-select
                                    v-if="item.rules"
                                    :localMode="true"
                                    :label="$tc('acris-faq.detail.fieldTitleLabelRule')"
                                    :helpText="$tc('acris-faq.detail.fieldTitleHelpTextRule')"
                                    :placeholder="$tc('acris-faq.detail.fieldTitlePlaceholderRule')"
                                    :entity-collection="item.rules"
                                    @update:entity-collection="onRulesChange">
                            </sw-entity-many-to-many-select>
                        {% endblock %}

                        {% block acris_faq_detail_content_display_collapsed_single_select %}
                            <sw-single-select v-model:value="item.collapsed"
                                              class="acris-faq-detail__item_collapsed"
                                              :label="$tc('acris-faq.detail.fieldTitleCollapsed')"
                                              :options="collapseOptions">
                            </sw-single-select>
                        {% endblock %}

                        {% block acris_faq_detail_content_group %}
                            <sw-entity-many-to-many-select
                                v-if="item.groups"
                                :localMode="true"
                                :label="$tc('acris-faq.detail.fieldTitleLabelGroups')"
                                :placeholder="$tc('acris-faq.detail.fieldTitlePlaceholderGroups')"
                                :helpText="$tc('acris-faq.detail.fieldTitleHelpTextGroups')"
                                :entity-collection="item.groups"
                                @update:entity-collection="onGroupsChange"
                                required>
                            </sw-entity-many-to-many-select>
                        {% endblock %}
                    </mt-card>
                {% endblock %}

                {% block acris_faq_detail_product_assignment_card %}
                    <mt-card :isLoading="isLoading" v-if="item"
                             position-identifier="acris-faq-detail-productAssignment"
                             :title="$tc('acris-faq.detail.cardProductAssignmentTitle')">
                        {% block acris_faq_detail_content_products %}
                            <acris-entity-many-to-many-select
                                    v-if="item.products"
                                    :localMode="true"
                                    :display-variants="true"
                                    :criteria="productCriteria"
                                    :context="productContext"
                                    :label="$tc('acris-faq.detail.fieldTitleLabelProduct')"
                                    :helpText="$tc('acris-faq.detail.fieldTitleHelpTextProduct')"
                                    :placeholder="$tc('acris-faq.detail.fieldTitlePlaceholderProduct')"
                                    :entity-collection="item.products"
                                    @update:entity-collection="onItemProductChange">

                                {% block sw_select_result_item_text  %}
                                    <template #selection-label-property="{ item }">
                                        <sw-product-variant-info :variations="item.variation" class="product-entity-selected">
                                            {{ item.productNumber }} - {{ item.translated.name || item.name }}
                                        </sw-product-variant-info>
                                    </template>
                                {% endblock %}

                                {% block sw_entity_many_to_many_select_base_results_list_result_label %}
                                    <template #result-label-property="{ item, index }">
                                        <sw-product-variant-info :variations="item.variation" class="product-entity-selected">
                                            {{ item.productNumber }} - {{ item.translated.name || item.name }}
                                        </sw-product-variant-info>
                                    </template>
                                {% endblock %}

                            </acris-entity-many-to-many-select>

                            <mt-banner>
                                {{ $tc('acris-faq.detail.productsInfoText') }}
                            </mt-banner>
                        {% endblock %}
                    </mt-card>
                {% endblock %}

                {% block acris_faq_content_keyword_card %}
                    <mt-card :isLoading="isLoading" v-if="item"
                             :title="$tc('acris-faq.detail.cardKeywordsTitle')"
                    >

                        {% block acris_faq_content_keyword_toolbar %}
                            <template #toolbar>
                                <acris-faq-keyword-card-filter placeholder="">
                                    <template #filter>
                                        {% block acris_faq_content_keyword_add_button %}
                                            <mt-button class="acris-faq-detail-field__add-field-action"
                                                       size="small"
                                                       @click="onCreateNewKeyword" variant="secondary">
                                                <mt-icon name="regular-plus-circle-s" size="16px"></mt-icon>
                                                {{ $tc('acris-faq.detail.buttonAddField') }}
                                            </mt-button>
                                        {% endblock %}
                                    </template>
                                </acris-faq-keyword-card-filter>
                            </template>
                        {% endblock %}


                        {% block acris_faq_content_keyword_grid %}
                            <template #grid>
                                <sw-one-to-many-grid v-if="item"
                                                     :collection="item.keywords"
                                                     :data-source="item.keywords"
                                                     ref="keywordGrid"
                                                     :localMode="true"
                                                     :columns="keywordColumns"
                                                     :showSelection="false"
                                                     @column-sort="setKeywordSorting"
                                                     :sortDirection="keywordSortDirection"
                                                     :sortBy="keywordSortProperty"
                                                     :isLoading="isLoading">

                                    {% block acris_faq_content_keyword_grid_columns %}
                                        {% block acris_faq_content_keyword_columns_internal_name %}
                                            <template #column-name="{ item }">
                                                <a @click="onEditKeyword(item.id)">
                                                    {{ item.name }}
                                                </a>
                                            </template>
                                        {% endblock %}
                                    {% endblock %}

                                    {% block acris_faq_content_keyword_grid_columns_actions %}
                                        <template #actions="{ item }">

                                            {% block acris_faq_content_keyword_grid_columns_actions_edit %}
                                                <sw-context-menu-item @click="onEditKeyword(item.id)">
                                                    {{ $tc('acris-faq.detail.contextMenuEdit') }}
                                                </sw-context-menu-item>
                                            {% endblock %}

                                            {% block acris_faq_content_keyword_grid_columns_actions_duplicate %}
                                                <sw-context-menu-item
                                                        @click="onDuplicate(item)">
                                                    {{ $tc('acris-faq.detail.contextMenuDuplicate') }}
                                                </sw-context-menu-item>
                                            {% endblock %}

                                            {% block acris_faq_content_keyword_grid_columns_actions_delete %}
                                                <sw-context-menu-item @click="onDeleteKeyword(item.id)"
                                                                      variant="danger">
                                                    {{ $tc('acris-faq.detail.contextMenuDelete') }}
                                                </sw-context-menu-item>
                                            {% endblock %}

                                        </template>
                                    {% endblock %}

                                    {% block acris_faq_content_keyword_grid_columns_action_modals %}
                                        <template #action-modals="{ item }">
                                            {% block acris_faq_content_keyword_delete_modal %}
                                                <sw-modal v-if="showDeleteKeywordModal === item.id"
                                                          @modal-close="onCloseDeleteKeywordModal"
                                                          :title="$tc('acris-faq.detail.modalTitleDeleteField')"
                                                          variant="small">
                                                    {% block acris_faq_content_keyword_delete_modal_confirm_delete_text %}
                                                        <p class="sw-product-detail-field__confirm-delete-text">
                                                            {{ $tc('acris-faq.detail.textDeleteKeywordConfirm') }}
                                                        </p>
                                                    {% endblock %}

                                                    {% block acris_faq_content_keyword_delete_modal_footer %}
                                                        <template #modal-footer>
                                                            {% block acris_config_steps_delete_modal_cancel %}
                                                                <mt-button @click="onCloseDeleteKeywordModal"
                                                                           size="small" variant="secondary">
                                                                    {{ $tc('acris-faq.detail.buttonCancel') }}
                                                                </mt-button>
                                                            {% endblock %}

                                                            {% block acris_faq_content_keyword_delete_modal_confirm %}
                                                                <mt-button @click="onConfirmDeleteKeyword(item.id)"
                                                                           variant="primary"
                                                                           size="small">
                                                                    {{ $tc('acris-faq.detail.buttonDelete') }}
                                                                </mt-button>
                                                            {% endblock %}
                                                        </template>
                                                    {% endblock %}
                                                </sw-modal>
                                            {% endblock %}
                                        </template>
                                    {% endblock %}
                                </sw-one-to-many-grid>
                            </template>
                        {% endblock %}

                    </mt-card>
                {% endblock %}


                {% block acris_faq_detail_image_card %}
                    <mt-card :isLoading="isLoading" :title="$tc('acris-faq.detail.cardImageTitle')" v-if="item.layout !== 'cms'"
                             position-identifier="acris-faq-detail-image">
                        {% block acris_faq_detail_image_card_position %}
                            <sw-single-select v-model:value="item.imagePosition"
                                              required
                                              :options="imagePositionOptions"
                                              class="acris-faq-detail__item_image_position"
                                              :label="$tc('acris-faq.detail.fieldTitleLabelImagePosition')"
                                              :placeholder="$tc('acris-faq.detail.fieldTitlePlaceholderImagePosition')">
                            </sw-single-select>
                        {% endblock %}

                        {% block acris_faq_detail_image_card_size %}
                            <sw-single-select v-model:value="item.imageSize"
                                              required
                                              :options="imageSizeOptions"
                                              class="acris-faq-detail__item_image_size"
                                              :label="$tc('acris-faq.detail.fieldTitleLabelImageSize')"
                                              :placeholder="$tc('acris-faq.detail.fieldTitlePlaceholderImageSize')">
                            </sw-single-select>
                        {% endblock %}

                        {% block acris_faq_detail_image_card_image_url_type %}
                            <sw-single-select v-model:value="item.imageUrlType"
                                              class="acris-faq-detail__item_image_url_type"
                                              :label="$tc('sw-category.base.link.mainTypeLabel')"
                                              :options="urlTypeOptions">
                            </sw-single-select>
                        {% endblock %}

                        {% block acris_faq_detail_image_card_image_url %}
                            <mt-text-field v-if="item.imageUrlType === 'external'"
                                           v-model="item.imageUrl"
                                           class="acris-faq-detail__item_image_url"
                                           :label="$tc('acris-faq.detail.fieldTitleLabelImageUrl')"
                                           :placeholder="$tc('acris-faq.detail.fieldTitlePlaceholderImageUrl')">
                            </mt-text-field>
                        {% endblock %}

                        {% block acris_faq_detail_image_card_image_url_entity %}
                            <sw-single-select v-if="item.imageUrlType === 'internal'"
                                              v-model:value="item.imageUrlEntity"
                                              class="acris-faq-detail__item_image_url_entity"
                                              :label="$tc('sw-category.base.entry-point-card.labelEntryPoint')"
                                              :options="urlEntityOptions"
                                              @change="changeEntity">
                            </sw-single-select>
                        {% endblock %}

                        {% block acris_faq_detail_image_card_image_select_entity_category %}
                            <sw-category-tree-field
                                v-if="item.imageUrlEntity === 'category' && item.imageUrlType === 'internal'"
                                v-model:value="item.imageInternalLink"
                                :categories-collection="categoriesCollection"
                                :placeholder="$tc('sw-category.base.link.categoryPlaceholder')"
                                :category-criteria="categoryCriteria"
                                :single-select="true"
                                :label="$tc('global.entities.category')"
                                class="acris-faq-detail__item_image_entity_category"
                                @selection-add="onSelectionAdd">
                            </sw-category-tree-field>
                        {% endblock %}

                        {% block acris_faq_detail_image_card_image_select_entity_product %}
                            <sw-entity-single-select
                                v-if="item.imageUrlEntity === 'product' && item.imageUrlType === 'internal'"
                                v-model:value="item.imageInternalLink"
                                class="acris-faq-detail__item_image_entity_product"
                                :label="$tc('global.entities.product')"
                                :placeholder="$tc('sw-category.base.link.productPlaceholder')"
                                :criteria="productCriteria"
                                :display-variants="true"
                                entity="product"
                                show-clearable-button>
                            </sw-entity-single-select>
                        {% endblock %}

                        {% block acris_faq_detail_image_card_image_select_landing_page %}
                            <sw-entity-single-select
                                v-if="item.imageUrlEntity === 'landing_page' && item.imageUrlType === 'internal'"
                                v-model:value="item.imageInternalLink"
                                :label="$tc('global.entities.landing_page')"
                                :placeholder="$tc('sw-category.base.link.landingPagePlaceholder')"
                                entity="landing_page"
                                show-clearable-button>
                            </sw-entity-single-select>
                        {% endblock %}

                        {% block acris_faq_detail_image_card_image_url_target %}
                            <sw-single-select v-model:value="item.imageUrlTarget"
                                              :options="imageUrlTargetOptions"
                                              class="acris-faq-detail__item_image_url_target"
                                              :label="$tc('acris-faq.detail.fieldTitleLabelImageUrlTarget')"
                                              :placeholder="$tc('acris-faq.detail.fieldTitlePlaceholderImageUrlTarget')"
                                              :helpText="$tc('acris-faq.detail.fieldTitleHelpTextImageUrlTarget')">
                            </sw-single-select>
                        {% endblock %}

                        {% block acris_faq_detail_image_card_image %}
                            <sw-upload-listener
                                :uploadTag="uploadTag"
                                autoUpload
                                @media-upload-finish="setMediaItem">
                            </sw-upload-listener>
                            <sw-media-upload-v2
                                variant="regular"
                                class="acris-faq-detail__image-upload"
                                :uploadTag="uploadTag"
                                :source="item.mediaId"
                                :allowMultiSelect="false"
                                :label="$tc('acris-faq.detail.labelUploadMedia')"
                                :defaultFolder="faqRepository.entityName"
                                :sourceContext="item"
                                @sw-media-upload-v2-media-upload-success="setMediaItem"
                                @media-drop="onDropMedia"
                                @media-upload-sidebar-open="openMediaSidebar"
                                @media-upload-remove-image="onUnlinkAvatar">
                            </sw-media-upload-v2>
                        {% endblock %}
                    </mt-card>
                {% endblock %}

                {% block acris_faq_detail_layout_card %}
                        <acris-generic-cms-page-assignment
                                v-if="item.layout === 'cms'"
                                :cms-page-id="item.cmsPageId"
                                @update:cms-page="updateCmsPage"
                                @create-layout="onCreateLayout">
                        </acris-generic-cms-page-assignment>
                {% endblock %}

                {% block acris_faq_detail_video_card %}
                    <mt-card :isLoading="isLoading" :title="$tc('acris-faq.detail.cardVideoTitle')"
                             position-identifier="acris-faq-detail-video"
                             v-if="item.layout !== 'cms'">
                        {% block acris_faq_detail_video_card_position %}
                            <sw-single-select v-model:value="item.videoPosition"
                                              required
                                              :options="videoPositionOptions"
                                              class="acris-faq-detail__item_video_position"
                                              :label="$tc('acris-faq.detail.fieldTitleLabelVideoPosition')"
                                              :placeholder="$tc('acris-faq.detail.fieldTitlePlaceholderVideoPosition')">
                            </sw-single-select>
                        {% endblock %}

                        {% block acris_faq_detail_video_card_type %}
                            <sw-single-select v-model:value="item.videoType"
                                              required
                                              :options="videoTypeOptions"
                                              class="acris-faq-detail__item_video_type"
                                              :label="$tc('acris-faq.detail.fieldTitleLabelVideoType')"
                                              :helpText="$tc('acris-faq.detail.fieldTitleHelpTextVideoType')"
                                              :placeholder="$tc('acris-faq.detail.fieldTitlePlaceholderVideoType')">
                            </sw-single-select>
                        {% endblock %}

                        {% block acris_faq_detail_video_card_video %}
                            <mt-text-field v-model="item.embedCode"
                                           :label="$tc('acris-faq.detail.labelEmbedCode')"
                                           :helpText="$tc('acris-faq.detail.helpTextEmbedCode')"
                                           :placeholder="$tc('acris-faq.detail.fieldEmbedCodePlaceholder')">
                            </mt-text-field>
                        {% endblock %}

                        {% block acris_faq_detail_content_video_privacy_mode_checkbox_select %}
                            <mt-switch v-model="item.videoPrivacyMode"
                                      v-if="item.videoType === 'youtube'"
                                      class="acris-faq-detail__item_video_privacy_mode"
                                      :label="$tc('acris-faq.detail.fieldTitleLabelVideoPrivacyMode')"
                                      :helpText="$tc('acris-faq.detail.fieldTitleHelpTextVideoPrivacyMode')">
                            </mt-switch>
                        {% endblock %}

                        {% block acris_faq_detail_content_video_player_controls_checkbox_select %}
                            <mt-switch v-model="item.videoPlayerControls"
                                      v-if="item.videoType === 'youtube'"
                                      class="acris-faq-detail__item_video_player_controls"
                                      :label="$tc('acris-faq.detail.fieldTitleLabelVideoPlayerControls')"
                                      :helpText="$tc('acris-faq.detail.fieldTitleHelpTextVideoPlayerControls')">
                            </mt-switch>
                        {% endblock %}
                    </mt-card>
                {% endblock %}

                {% block acris_faq_detail_document_card %}
                    <mt-card :isLoading="isLoading" :title="$tc('acris-faq.detail.cardDocumentTitle')"
                             position-identifier="acris-faq-detail-document"
                             v-if="item.layout !== 'cms'">
                        {% block acris_faq_detail_document_card_form %}
                            <acris-faq-document-form v-if="item"
                                                     :faq="item"
                                                     :refs="$refs"
                                                     @media-open="onOpenDocumentModal">
                            </acris-faq-document-form>
                        {% endblock %}
                    </mt-card>
                {% endblock %}

                {% block acris_faq_detail_content_card_seo %}
                    <mt-card :isLoading="isLoading" v-if="item"
                             position-identifier="acris-faq-detail-seo"
                             :title="$tc('acris-faq.detail.cardSeo')">

                        {% block acris_faq_detail_content_look_seo_url %}
                            <mt-text-field v-model="item.seoUrl"
                                           class="acris-faq-detail__item_seo_url"
                                           :label="$tc('acris-faq.detail.fieldTitleLabelSeoUrl')"
                                           :helpText="$tc('acris-faq.detail.fieldTitleHelpTextSeoUrl')"
                                           :placeholder="placeholder(item, 'seoUrl', $tc('acris-faq.detail.fieldTitlePlaceholderSeoUrl'))">
                            </mt-text-field>
                        {% endblock %}

                        {% block acris_faq_detail_content_look_meta_title %}
                            <mt-text-field v-model="item.metaTitle"
                                           class="acris-faq-detail__item_meta_title"
                                           :label="$tc('acris-faq.detail.fieldTitleLabelMetaTitle')"
                                           :helpText="$tc('acris-faq.detail.fieldTitleHelpTextMetaTitle')"
                                           :placeholder="placeholder(item, 'metaTitle', $tc('acris-faq.detail.fieldTitlePlaceholderMetaTitle'))">
                            </mt-text-field>
                        {% endblock %}

                        {% block acris_faq_detail_content_look_meta_description %}
                            <mt-text-field v-model="item.metaDescription"
                                           class="acris-faq-detail__item_meta_description"
                                           :label="$tc('acris-faq.detail.fieldTitleLabelMetaDescription')"
                                           :helpText="$tc('acris-faq.detail.fieldTitleHelpTextMetaDescription')"
                                           :placeholder="placeholder(item, 'metaDescription', $tc('acris-faq.detail.fieldTitlePlaceholderMetaDescription'))">
                            </mt-text-field>
                        {% endblock %}

                        {% block acris_faq_detail_content_look_meta_data %}
                            <sw-single-select v-model:value="item.metaDataOption"
                                              class="acris-faq-detail__item_meta_data"
                                              :label="$tc('acris-faq.detail.fieldTitleLabelMetaData')"
                                              :options="metaDataOptions">
                            </sw-single-select>
                        {% endblock %}

                    </mt-card>
                {% endblock %}

            </sw-card-view>
        </template>
        {% endblock %}

        {% block acris_faq_detail_index_sidebar %}
            <template #sidebar>
                <sw-sidebar v-if="acl.can('media.editor')" :propagate-width="true">
                    <sw-sidebar-media-item ref="mediaSidebarItem"
                                           :isParentLoading="isLoading">

                        <template #context-menu-items="media">
                            <sw-context-menu-item @click="setMediaFromSidebar(media.mediaItem)">
                                {{ $tc('acris-faq.detail.labelMedia') }}
                            </sw-context-menu-item>
                        </template>
                    </sw-sidebar-media-item>
                </sw-sidebar>
            </template>
        {% endblock %}
        {% block acris_edit_document_modal %}
            <sw-modal class="acris-edit-lexicon-document-modal"
                      :title="$tc('acris-edit-lexicon-document-modal.title')"
                      @modal-close="onCancel">

                {% block acris_edit_document_modal_footer %}
                    <template #modal-footer>

                        {% block acris_edit_document_modal_footer_button_cancel %}
                            <mt-button size="small" @click="onCancel" variant="secondary">
                                {{ $tc('global.default.cancel') }}
                            </mt-button>
                        {% endblock %}

                        {% block acris_edit_document_modal_footer_button_apply %}
                            <mt-button variant="primary" size="small" @click="onApply">
                                {{ $tc('global.default.apply') }}
                            </mt-button>
                        {% endblock %}
                    </template>
                {% endblock %}
            </sw-modal>
        {% endblock %}

    </sw-page>
{% endblock %}
